import { ca } from '@cian/analytics';

export function trackCalculateClick() {
  ca('eventSite', {
    name: 'oldevent',
    action: 'click',
    category: 'invest_calculator',
    label: 'calculate',
  });
}
